import { createContext, useContext } from 'react';

/** Defers optional UI dialogs without touching notification delivery or OS prompt rules. */
export const CommunityTourContext = createContext(false);
export const useCommunityTourDeferred = () => useContext(CommunityTourContext);